import React from "react";
import FormField from "./FormField";
import InputMask from "react-input-mask";

/**
 *
 * @param {MaskedField.defaultProps} props
 * @returns
 */
const MaskedField = (props) => {
  return <FormField {...props} />;
};

MaskedField.defaultProps = {
  ...FormField.defaultProps,
  mask: "999-999-9999",
  maskChar: "",
  /** Strip masking to save raw values instead of masked input.*/
  stripRegex: /-/g,
  renderControl: (props, showError, fieldValue, onChange) => (
    <InputMask
      mask={props.mask}
      className={showError ? "form-control is-invalid" : "form-control"}
      name={props.fieldName}
      id={props.fieldName}
      value={fieldValue}
      placeholder={props.placeholder}
      maskChar={props.maskChar}
      onChange={(e) => onChange(e.target.value.replace(props.stripRegex, ""))}
      onBlur={(e) => onChange(e.target.value.replace(props.stripRegex, ""))}
      disabled={props.disabled}
    />
  ),
};

export default MaskedField;
